package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

// --- RESET GLOBAL PARA ELIMINAR SCROLL FANTASMA (MANTENIDO) ---
object LoginAdminStylesheet : StyleSheet() {
    init {
        "html, body" style {
            margin(0.px)
            padding(0.px)
            width(100.percent)
            height(100.percent)
            property("overflow", "hidden") 
            backgroundColor(Color("#147CD0"))
        }
    }
}

@Composable
private fun LoadingScreen() {
    Div({
        style {
            display(DisplayStyle.Flex); width(100.vw); height(100.vh)
            backgroundColor(Color("#147CD0")); justifyContent(JustifyContent.Center)
            alignItems(AlignItems.Center); flexDirection(FlexDirection.Column); gap(24.px)
        }
    }) {
        Img(src = "logo_icon.svg", attrs = { style { width(200.px); height(200.px) } })
        H2({ style { color(Color.white); fontFamily("sans-serif") } }) { Text("Verificando credenciales...") }
    }
}

@Composable
fun LoginAdminScreen(viewModel: LoginAdminViewModel) {
    val uiState by viewModel.uiState.collectAsState()
    
    // Inyectamos el reset de CSS
    Style(LoginAdminStylesheet)

    if (uiState.isLoading) {
        LoadingScreen()
    } else {
        // --- CONTENEDOR MAESTRO (FIJO E IMPONENTE) ---
        Div({
            style {
                display(DisplayStyle.Flex)
                width(100.vw)
                height(100.vh)
                fontFamily("sans-serif")
                boxSizing("border-box")
            }
        }) {
            // --- COLUMNA IZQUIERDA (MANDO - 30%) ---
            Div({
                style {
                    width(30.percent)
                    height(100.percent)
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center)
                    backgroundColor(Color("#FB8C00"))
                    property("box-shadow", "10px 0px 30px rgba(0, 0, 0, 0.2)")
                    boxSizing("border-box")
                }
            }) {
                // --- CUADRO BLANCO (CONTENEDOR DE ACCESO) ---
                Div({
                    style {
                        width(100.percent)
                        maxWidth(450.px)
                        maxHeight(98.vh)
                        padding(16.px)
                        border(1.px, LineStyle.Solid, Color("#cccccc"))
                        borderRadius(16.px)
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(10.px)
                        backgroundColor(Color.white)
                        boxSizing("border-box")
                        property("overflow-y", "auto")
                    }
                }) {
                    // --- ESTANDARTE ---
                    Div({
                        style {
                            display(DisplayStyle.Flex);
                            flexDirection(FlexDirection.Column);
                            alignItems(AlignItems.Center); marginBottom(4.px) } }) {
                        Img(src = "logo_icon.svg", attrs = { style { width(65.px); height(65.px) } })
                        H2({ style { fontSize(22.px); color(Color("#1976D2")); margin(0.px); marginTop(4.px) } }) {
                            Span({ style { fontWeight("normal") } }) { Text("Línea ") }
                            Span({ style { fontWeight("bold") } }) { Text("Muni") }
                        }
                        P({ style { fontSize(12.px); color(Color("#FB8C00")); fontWeight("bold"); margin(0.px); letterSpacing(1.px) } }) { Text("SMART CITY") }
                    }

                    H1({ style { fontSize(18.px); color(Color("#1976D2")); textAlign("center"); margin(0.px); marginBottom(4.px) } }) { Text("Acceso Panel de Control") }

                    // --- REGION ---
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px) } }) {
                        Label(attrs = { style { fontSize(11.px); fontWeight("bold"); color(Color("#757575")) } }) { Text("REGIÓN") }
                        Select(attrs = {
                            style {
                                fontSize(14.px); height(40.px); width(100.percent); padding(0.px, 12.px)
                                borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#1976D2"))
                                backgroundColor(Color("#F5F5F5"))
                            }
                            onInput { event ->
                                event.value?.let { viewModel.onRegionChanged(it) }
                            }
                        }) {
                            Option("", attrs = { if (uiState.regionSeleccionada == null) selected() }) { Text("Seleccione Región...") }
                            uiState.regiones.forEach { region ->
                                Option(region.id, attrs = { if (uiState.regionSeleccionada?.id == region.id) selected() }) { Text(region.nombre) }
                            }
                        }
                    }

                    // --- COMUNA ---
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px) } }) {
                        Label(attrs = { style { fontSize(11.px); fontWeight("bold"); color(Color("#757575")) } }) { Text("COMUNA") }
                        Select(attrs = {
                            style {
                                fontSize(14.px); height(40.px); width(100.percent); padding(0.px, 12.px)
                                borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#1976D2"))
                                backgroundColor(Color("#F5F5F5"))
                            }
                            onInput { event ->
                                event.value?.let { viewModel.onComunaChanged(it) }
                            }
                            if (uiState.regionSeleccionada == null || uiState.regionSeleccionada?.id == "NACIONAL") disabled()
                        }) {
                            if (uiState.regionSeleccionada?.id == "NACIONAL") {
                                Option("NACIONAL", attrs = { selected() }) { Text("TODO EL PAÍS") }
                            } else {
                                Option("", attrs = { if (uiState.comunaSeleccionadaObj == null) selected() }) { Text("Seleccione Comuna...") }
                                uiState.comunasFiltradas.forEach { comuna ->
                                    Option(comuna.id, attrs = { if (uiState.comunaSeleccionadaObj?.id == comuna.id) selected() }) { Text(comuna.comunaDisplayName) }
                                }
                            }
                        }
                    }

                    Input(type = InputType.Email, attrs = {
                        placeholder("Email de Administrador")
                        style { fontSize(16.px); height(45.px); width(100.percent); padding(12.px); boxSizing("border-box"); borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#ccc")) }
                        value(uiState.email)
                        onInput { viewModel.onEmailChanged(it.value) }
                    })

                    Input(type = InputType.Password, attrs = {
                        placeholder("Contraseña")
                        style { fontSize(16.px); height(45.px); width(100.percent); padding(12.px); boxSizing("border-box"); borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#ccc")) }
                        value(uiState.contrasena)
                        onInput { viewModel.onContrasenaChanged(it.value) }
                    })

                    // --- 1. MANDO ESTRATÉGICO ---
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(10.px) } }) {
                        Label(attrs = { style { fontSize(12.px); fontWeight("bold"); color(Color("#757575")); marginTop(8.px) } }) { Text("NIVEL ESTRATÉGICO") }
                        BotonEntrada("ADM. COMUNAL (ALCALDÍA)", "#1976D2", viewModel) { viewModel.intentarLogin("COMUNAL") }
                        BotonEntrada("DIR. SERVICIOS URBANOS (DAO)", "#AD1457", viewModel) { viewModel.intentarLogin("DIRECCION_DAO") }
                    }

                    // --- 2. MANDO OPERATIVO ---
                    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(10.px) } }) {
                        Label(attrs = { style { fontSize(12.px); fontWeight("bold"); color(Color("#757575")); marginTop(8.px) } }) { Text("MANDO OPERATIVO") }
                        
                        Div({ style { display(DisplayStyle.Flex); gap(8.px); width(100.percent) } }) {
                             BotonTagMini("DRONES", "#000000", viewModel) { viewModel.intentarLogin("OPERADOR_DRON") }
                             BotonTagMini("CÁMARAS", "#AD1457", viewModel) { viewModel.intentarLogin("OPERADOR_CAMARAS") }
                             BotonTagMini("CENTRAL", "#FB8C00", viewModel) { viewModel.intentarLogin("OPERADORA") }
                        }
                    }

                    Hr({ style { width(100.percent); margin(12.px, 0.px); opacity(0.3) } })

                    // --- 3. SERVICIOS ---
                    Div({
                        style {
                            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(10.px)
                            maxHeight(200.px); property("overflow-y", "auto"); paddingRight(8.px)
                        }
                    }) {
                        uiState.tiposServicio.forEach { servicio ->
                            BotonEntrada("ACCESO ${servicio.nombreDisplay?.uppercase() ?: servicio.nombre.uppercase()}", "#388E3C", viewModel) {
                                viewModel.intentarLogin(servicio.nombre)
                            }
                        }
                    }

                    if (uiState.error != null) {
                        P({ style { color(Color.red); fontSize(14.px); fontWeight("bold"); textAlign("center"); margin(0.px); backgroundColor(Color("#FFEBEE")); padding(10.px); borderRadius(8.px) } }) { Text(uiState.error!!) }
                    }
                }
            }

            // --- COLUMNA DERECHA (ESTÉTICA - 70%) ---
            Div({
                style {
                    width(70.percent)
                    display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                    backgroundColor(Color("#1976D2")); padding(50.px); boxSizing("border-box")
                    flexDirection(FlexDirection.Column)
                    position(Position.Relative) // <--- CLAVE PARA EL ANCLAJE DEL BOTÓN G
                }
            }) {
                Div({ 
                    style { 
                        display(DisplayStyle.Flex); 
                        flexDirection(FlexDirection.Column); 
                        alignItems(AlignItems.Center) } }) {
                    Img(src = "logo_icon.svg", attrs = { style { height(220.px); property("filter", "drop-shadow(0px 10px 20px rgba(0,0,0,0.3))") } })
                    H2({ style { fontSize(80.px); color(Color.white); margin(0.px); marginTop(16.px); fontWeight("bold") } }) {
                        Text("CHILE")
                    }
                    P({ style { fontSize(28.px); color(Color("#FB8C00")); fontWeight("bold"); margin(0.px); letterSpacing(4.px); marginTop((-10).px) } }) {
                        Text("SMART CITY")
                    }
                }

                // --- BLOQUE FAQ Y SOPORTE ---
                Div({
                    style {
                        marginTop(40.px); width(100.percent); maxWidth(600.px)
                        backgroundColor(Color("rgba(255,255,255,0.1)")); padding(30.px)
                        borderRadius(20.px); border(1.px, LineStyle.Solid, Color("rgba(255,255,255,0.2)"))
                    }
                }) {
                    H3({ style { color(Color.white); fontSize(24.px); marginBottom(16.px) } }) { Text("Preguntas Frecuentes (FAQ)") }
                    
                    P({ style { color(Color("#FB8C00")); fontWeight("bold"); marginBottom(4.px) } }) { Text("¿Cómo obtengo mi acceso?") }
                    P({ style { color(Color.white); fontSize(14.px); marginBottom(16.px); opacity(0.9) } }) { 
                        Text("Las credenciales son gestionadas por el Administrador General de su comuna. Si es personal nuevo, solicite su alta en el sistema.") 
                    }

                    P({ style { color(Color("#FB8C00")); fontWeight("bold"); marginBottom(4.px) } }) { Text("¿Es seguro el sistema?") }
                    P({ style { color(Color.white); fontSize(14.px); opacity(0.9) } }) { 
                        Text("Línea Muni utiliza cifrado de extremo a extremo y protocolos de seguridad de Google Cloud para proteger la información ciudadana.") 
                    }
                }
                Div({ style { marginTop(20.px); textAlign("center") } }) {
                    P({ style { color(Color.white); fontSize(15.px); fontWeight("bold"); marginBottom(6.px) } }) {
                        Text("LíneaMuni - Plataforma Smart City desarrollada y operada por CONEXCITY Ltda.")
                    }
                    P({ style { color(Color("rgba(255,255,255,0.85)")); fontSize(13.px); marginBottom(4.px) } }) {
                        Text("Marca Reg. INAPI 1668601 | Prop. Intelectual DDI 9z4b65")
                    }
                    P({ style { color(Color.white); fontSize(12.px); fontWeight("bold"); marginBottom(6.px) } }) {
                        Text("Desarrollada por Ing. Master Smart City Waldo Sankán M.")
                    }
                    P({ style { color(Color.white); fontSize(15.px) } }) {
                        Text("Soporte Técnico: ")
                        Span({ style { color(Color("#FB8C00")); fontWeight("bold") } }) { Text("lineamuni@gmail.com") }
                    }
                    Div({ style { marginTop(10.px); display(DisplayStyle.Flex); gap(20.px); justifyContent(JustifyContent.Center) } }) {
                        A(href = "https://lineamuni.cl/privacidad.html", attrs = {
                            style { color(Color.white); textDecoration("underline"); fontSize(14.px) }
                            attr("target", "_blank")
                        }) { Text("Políticas de Privacidad") }
                        
                        A(href = "https://lineamuni.cl", attrs = { 
                            style { color(Color.white); textDecoration("underline"); fontSize(14.px) }
                            attr("target", "_blank")
                        }) { Text("Sitio Oficial Chile") }
                    }
                }

                // --- ACCESO GENERAL (AHORA SÍ VISIBLE Y POSICIONADO) ---
                Div({
                    onClick { viewModel.intentarLogin("GENERAL") }
                    style {
                        position(Position.Absolute); right(30.px); bottom(30.px)
                        opacity(0.6); cursor("pointer"); padding(10.px)
                        color(Color.white); fontSize(18.px); fontWeight("bold")
                        border(2.px, LineStyle.Solid, Color.white)
                        borderRadius(50.percent); width(40.px); height(40.px)
                        display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
                        property("transition", "0.3s all")
                        // Efecto hover táctico
                        property("box-shadow", "0px 0px 15px rgba(255,255,255,0.2)")
                    }
                }) { Text("G") }
            }
        }
    }
}

@Composable
private fun BotonEntrada(label: String, colorHex: String, viewModel: LoginAdminViewModel, onClick: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    Button(attrs = {
        if (uiState.isLoading) disabled()
        onClick { onClick() }
        style {
            minHeight(48.px); width(100.percent); padding(8.px, 16.px); fontSize(15.px); fontWeight("bold")
            color(Color.white); backgroundColor(Color(colorHex)); borderRadius(8.px)
            cursor("pointer"); border(0.px); property("transition", "0.3s all")
            if (uiState.isLoading) opacity(0.6)
        }
    }) { Text(if (uiState.isLoading) "..." else label) }
}

@Composable
private fun BotonEntradaMini(label: String, colorHex: String, viewModel: LoginAdminViewModel, onClick: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    Button(attrs = {
        if (uiState.isLoading) disabled()
        onClick { onClick() }
        style {
            flex(1)
            minHeight(40.px); padding(4.px, 8.px); fontSize(13.px); fontWeight("bold")
            color(Color.white); backgroundColor(Color(colorHex)); borderRadius(6.px)
            cursor("pointer"); border(0.px); property("transition", "0.3s all")
            if (uiState.isLoading) opacity(0.6)
        }
    }) { Text(if (uiState.isLoading) "..." else label) }
}

@Composable
private fun BotonTagMini(label: String, colorHex: String, viewModel: LoginAdminViewModel, onClick: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    Div({
        if (!uiState.isLoading) onClick { onClick() }
        style {
            flex(1)
            padding(8.px, 4.px); fontSize(10.px); fontWeight("bold")
            color(Color.white); backgroundColor(Color(colorHex)); borderRadius(6.px)
            cursor("pointer"); property("transition", "0.2s all")
            textAlign("center")
            if (uiState.isLoading) opacity(0.6)
            property("user-select", "none")
            display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
        }
    }) { Text(label) }
}

@Composable
private fun BotonTag(label: String, colorHex: String, viewModel: LoginAdminViewModel, onClick: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    Div({
        if (!uiState.isLoading) onClick { onClick() }
        style {
            padding(6.px, 12.px); fontSize(11.px); fontWeight("bold")
            color(Color.white); backgroundColor(Color(colorHex)); borderRadius(100.px)
            cursor("pointer"); property("transition", "0.2s all")
            if (uiState.isLoading) opacity(0.6)
            property("user-select", "none")
        }
    }) { Text(label) }
}
